import {CONFIG} from "../../config";
import axios from "axios";

async function GetUserNotificationsLimitedQuery(pageNr, onPage){
    const location = CONFIG.API_URL + "user_notification/get/" + pageNr + "/" + onPage;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    
    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetUserNotificationsLimitedQuery;